import { useSelectionStore } from '@/state/selection';
import { RVT_LAYER } from './layer';
import { useRvtStore } from './rvt';

// Names the reader could not frame cleanly come out as stray glyphs; those read as none.
const readable = (s: string) => (/[A-Za-z0-9]/.test(s) ? s : '');

// The clicked Revit element: what the element table knows about it.
export function RevitCard() {
  const selected = useSelectionStore((s) => s.selected);
  const select = useSelectionStore((s) => s.select);
  const elements = useRvtStore((s) => s.elements);
  const meshes = useRvtStore((s) => s.meshes);
  if (!selected || selected.layer !== RVT_LAYER) return null;

  const el = elements.find((e) => e.id === selected.expressID);
  const source = meshes.find((m) => m.expressId === selected.expressID)?.source;
  const rows: [string, string][] = [
    ['id', String(selected.expressID)],
    ['category', el?.category || '–'],
    ['family', readable(el?.name ?? '') || '–'],
    ['type', readable(el?.typeName ?? '') || '–'],
    ['level', el?.level || '–'],
    ['geometry', source === 'solid' ? 'solid' : source === 'box' ? 'bounding box' : '–'],
  ];

  return (
    <div className="lens-panel card">
      <div className="lens-bar">
        <span className="lens-dot" />
        <span>revit element</span>
        <button
          className="lens-close"
          type="button"
          onClick={() => select(null)}
          aria-label="Close"
        >
          ×
        </button>
      </div>
      <dl className="kv">
        {rows.map(([k, v]) => (
          <div key={k}>
            <dt>{k}</dt>
            <dd title={v}>{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
